<template>
    <div id="glass-products-page">
        <h1>{{ trans('pages.glass_products.title') }}</h1>

        <spinner-text v-if="!products">
            {{ trans('pages.glass_products.loading') }}
        </spinner-text>

        <template v-else>
            <div class="actions">
                <ui5-button @click="setStatus('IM')">
                    {{ trans('pages.glass_products.update_to_im') }}
                </ui5-button>
            </div>

            <div v-if="products.length == 0">
                {{ trans('pages.glass_products.no_products') }}
            </div>

            <div
                class="products"
                v-else
            >
                <div
                    class="product"
                    v-for="product in products"
                    :key="product.productId"
                >
                    <ui5-checkbox
                        :checked="product.selected"
                        @change="product.selected = $event.target.checked"
                    />
                    <div>
                        <i
                            class="fa fa-info-circle back"
                            @click="
                                $router.push(
                                    '/productpage/' + product.productId
                                )
                            "
                        />
                    </div>
                    <ui5-input
                        type="Text"
                        :value="product.productNr"
                        readonly
                    />
                    <ui5-input
                        type="Text"
                        :value="
                            product.name ||
                            trans('pages.glass_products.no_product_reference')
                        "
                        readonly
                    />
                    <ui5-input
                        type="Text"
                        :value="product.orderId"
                        readonly
                    />
                    <ui5-input
                        type="text"
                        :value="
                            product.reference ||
                            trans('pages.glass_products.no_order_reference')
                        "
                        readonly
                    />
                    <ui5-input
                        type="Text"
                        :value="product.productstatus"
                        readonly
                    />
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import statusApi from '../api/status';
import glassProductsApi from '../api/glassProducts';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    data() {
        return {
            products: null,
        };
    },
    components: { SpinnerText },
    mixins: [localization],
    methods: {
        load() {
            this.products = null;
            glassProductsApi.fetchExportableProducts().then((response) => {
                const products = response.data.data || [];
                products.forEach((x) => {
                    x.selected = false;
                });
                this.products = products;
            });
        },
        setStatus(status) {
            if (!this.selected || !this.selected.length) {
                return showErrorMessage(
                    this.trans('pages.glass_products.error_no_selection')
                );
            }

            statusApi
                .updateProductStatusBatch(
                    status,
                    this.selected.map((x) => x.productNr)
                )
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.glass_products.success_status_change',
                            { status: status }
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.glass_products.error_status_change', {
                            products: error.response.data.fail.join(', '),
                        })
                    );
                });
        },
    },
    computed: {
        selected() {
            if (!this.products) {
                return null;
            }
            return this.products.filter((x) => x.selected);
        },
    },
    mounted() {
        this.load();
    },
};
</script>
